import { render, staticRenderFns } from "./QuestionParagraph.vue?vue&type=template&id=774869f4&scoped=true&"
import script from "./QuestionParagraph.vue?vue&type=script&lang=js&"
export * from "./QuestionParagraph.vue?vue&type=script&lang=js&"
import style0 from "./QuestionParagraph.vue?vue&type=style&index=0&id=774869f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774869f4",
  null
  
)

export default component.exports